import "./main-layout.scss";
import BodyComponent from "./body/body";
import HeaderScreen from "./header/header.screen";
import { SlideBarComponent } from "./sidebar/slide-bar.component";

const MainLayout = () => {
  return (
    <article className="root_container">
      <div className="root_slidebar">
         <SlideBarComponent/>
      </div>
      <div className="root_body">
        <div className="header-container">
          <HeaderScreen />
        </div>
        <BodyComponent />
      </div>
    </article>
  );
};

export default MainLayout;
